import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/site/Seo";

export default function NotFoundPage() {
  return <section id="top" className="min-h-[65vh] pt-40 pb-24 px-6 md:px-12 lg:px-20" data-testid="not-found-page">
    <Seo title="Page not found | Garg Stone Company" description="This page isn't in the Garg Stone Company collection." path="/404" noindex />
    <p className="text-copper font-editorial text-xl mb-5">404</p>
    <h1 className="text-4xl sm:text-5xl font-heading" data-testid="not-found-heading">This page isn’t in the collection.</h1>
    <Link to="/#products" className="inline-flex gap-2 items-center mt-10 text-copper transition-colors hover:text-bone" data-testid="not-found-collection-link"><ArrowLeft size={18} /> Return to the collection</Link>
  </section>;
}